<template>
  <div id="animation">
    <div v-show="f1" class="animation">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 648 648">
        <rect
          width="24"
          height="24"
          style="transform: translate(240px, 48px)"
          fill="#ff0000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(288px, 48px)"
          fill="#ff0000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(336px, 48px)"
          fill="#ff0000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(192px, 72px)"
          fill="#000000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(216px, 72px)"
          fill="#000000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(240px, 72px)"
          fill="#ff0000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(264px, 72px)"
          fill="#ff0000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(288px, 72px)"
          fill="#ff0000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(312px, 72px)"
          fill="#ff0000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(336px, 72px)"
          fill="#ff0000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(168px, 96px)"
          fill="#000000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(192px, 96px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(216px, 96px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(240px, 96px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(264px, 96px)"
          fill="#ff0000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(288px, 96px)"
          fill="#ff0000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(312px, 96px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(168px, 120px)"
          fill="#000000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(192px, 120px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(216px, 120px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(240px, 120px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(264px, 120px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(288px, 120px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(312px, 120px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(168px, 144px)"
          fill="#000000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(192px, 144px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(216px, 144px)"
          fill="#000000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(240px, 144px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(264px, 144px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(288px, 144px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(312px, 144px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(120px, 168px)"
          fill="#ffaf00"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(144px, 168px)"
          fill="#ffaf00"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(168px, 168px)"
          fill="#ffaf00"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(192px, 168px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(216px, 168px)"
          fill="#000000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(240px, 168px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(264px, 168px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(288px, 168px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(312px, 168px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(528px, 168px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(96px, 192px)"
          fill="#ffaf00"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(120px, 192px)"
          fill="#ffaf00"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(144px, 192px)"
          fill="#ffaf00"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(168px, 192px)"
          fill="#ffaf00"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(192px, 192px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(216px, 192px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(240px, 192px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(264px, 192px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(288px, 192px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(312px, 192px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(504px, 192px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(528px, 192px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(120px, 216px)"
          fill="#ffaf00"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(144px, 216px)"
          fill="#ffaf00"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(168px, 216px)"
          fill="#ffaf00"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(192px, 216px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(216px, 216px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(240px, 216px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(264px, 216px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(288px, 216px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(312px, 216px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(504px, 216px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(528px, 216px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(144px, 240px)"
          fill="#ff0000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(168px, 240px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(192px, 240px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(216px, 240px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(240px, 240px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(264px, 240px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(288px, 240px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(312px, 240px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(336px, 240px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(360px, 240px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(384px, 240px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(408px, 240px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(432px, 240px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(456px, 240px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(480px, 240px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(504px, 240px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(528px, 240px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(144px, 264px)"
          fill="#ff0000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(168px, 264px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(192px, 264px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(216px, 264px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(240px, 264px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(264px, 264px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(288px, 264px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(312px, 264px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(336px, 264px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(360px, 264px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(384px, 264px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(408px, 264px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(432px, 264px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(456px, 264px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(480px, 264px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(504px, 264px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(528px, 264px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(168px, 288px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(192px, 288px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(216px, 288px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(240px, 288px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(264px, 288px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(288px, 288px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(312px, 288px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(336px, 288px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(360px, 288px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(384px, 288px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(408px, 288px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(432px, 288px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(456px, 288px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(480px, 288px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(504px, 288px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(528px, 288px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(168px, 312px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(192px, 312px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(216px, 312px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(240px, 312px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(264px, 312px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(288px, 312px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(312px, 312px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(336px, 312px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(360px, 312px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(384px, 312px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(408px, 312px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(432px, 312px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(456px, 312px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(480px, 312px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(504px, 312px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(528px, 312px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(168px, 336px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(192px, 336px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(216px, 336px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(240px, 336px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(264px, 336px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(288px, 336px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(312px, 336px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(336px, 336px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(360px, 336px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(384px, 336px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(408px, 336px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(432px, 336px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(456px, 336px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(480px, 336px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(504px, 336px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(528px, 336px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(168px, 360px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(192px, 360px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(216px, 360px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(240px, 360px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(264px, 360px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(288px, 360px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(312px, 360px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(336px, 360px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(360px, 360px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(384px, 360px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(408px, 360px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(432px, 360px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(456px, 360px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(480px, 360px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(504px, 360px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(168px, 384px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(192px, 384px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(216px, 384px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(240px, 384px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(264px, 384px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(288px, 384px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(312px, 384px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(336px, 384px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(360px, 384px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(384px, 384px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(408px, 384px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(432px, 384px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(456px, 384px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(480px, 384px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(504px, 384px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(168px, 408px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(192px, 408px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(216px, 408px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(240px, 408px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(264px, 408px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(288px, 408px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(312px, 408px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(336px, 408px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(360px, 408px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(384px, 408px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(408px, 408px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(432px, 408px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(456px, 408px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(480px, 408px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(192px, 432px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(216px, 432px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(240px, 432px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(264px, 432px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(288px, 432px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(312px, 432px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(336px, 432px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(360px, 432px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(384px, 432px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(408px, 432px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(432px, 432px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(456px, 432px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(480px, 432px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(240px, 456px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(264px, 456px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(288px, 456px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(312px, 456px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(336px, 456px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(360px, 456px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(384px, 456px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(408px, 456px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(432px, 456px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(456px, 456px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(288px, 480px)"
          fill="#ffaf00"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(384px, 480px)"
          fill="#ffaf00"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(288px, 504px)"
          fill="#ffaf00"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(384px, 504px)"
          fill="#ffaf00"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(264px, 528px)"
          fill="#ffaf00"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(288px, 528px)"
          fill="#ffaf00"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(312px, 528px)"
          fill="#ffaf00"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(360px, 528px)"
          fill="#ffaf00"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(384px, 528px)"
          fill="#ffaf00"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(408px, 528px)"
          fill="#ffaf00"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(48px, 552px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(72px, 552px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(96px, 552px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(120px, 552px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(144px, 552px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(168px, 552px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(192px, 552px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(216px, 552px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(240px, 552px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(264px, 552px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(288px, 552px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(312px, 552px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(336px, 552px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(360px, 552px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(384px, 552px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(408px, 552px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(432px, 552px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(456px, 552px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(480px, 552px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(504px, 552px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(528px, 552px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(552px, 552px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(576px, 552px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(48px, 576px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(72px, 576px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(96px, 576px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(120px, 576px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(144px, 576px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(168px, 576px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(192px, 576px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(216px, 576px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(240px, 576px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(264px, 576px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(288px, 576px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(312px, 576px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(336px, 576px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(360px, 576px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(384px, 576px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(408px, 576px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(432px, 576px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(456px, 576px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(480px, 576px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(504px, 576px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(528px, 576px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(552px, 576px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(576px, 576px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(48px, 600px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(72px, 600px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(96px, 600px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(120px, 600px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(144px, 600px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(168px, 600px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(192px, 600px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(216px, 600px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(240px, 600px)"
          fill="#bb9302"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(264px, 600px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(288px, 600px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(312px, 600px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(336px, 600px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(360px, 600px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(384px, 600px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(408px, 600px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(432px, 600px)"
          fill="#bb9302"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(456px, 600px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(480px, 600px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(504px, 600px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(528px, 600px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(552px, 600px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(576px, 600px)"
          fill="#bb9302"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(48px, 624px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(72px, 624px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(96px, 624px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(120px, 624px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(144px, 624px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(168px, 624px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(192px, 624px)"
          fill="#bb9302"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(216px, 624px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(240px, 624px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(264px, 624px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(288px, 624px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(312px, 624px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(336px, 624px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(360px, 624px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(384px, 624px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(408px, 624px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(432px, 624px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(456px, 624px)"
          fill="#bb9302"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(480px, 624px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(504px, 624px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(528px, 624px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(552px, 624px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(576px, 624px)"
          fill="#bb6502"
        />
      </svg>
    </div>
    <div v-show="f0" class="animation" style="display: none">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 648 648">
        <rect
          width="24"
          height="24"
          style="transform: translate(264px, 24px)"
          fill="#ff0000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(312px, 24px)"
          fill="#ff0000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(192px, 48px)"
          fill="#000000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(216px, 48px)"
          fill="#000000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(240px, 48px)"
          fill="#ff0000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(264px, 48px)"
          fill="#ff0000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(288px, 48px)"
          fill="#ff0000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(312px, 48px)"
          fill="#ff0000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(336px, 48px)"
          fill="#ff0000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(168px, 72px)"
          fill="#000000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(192px, 72px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(216px, 72px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(240px, 72px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(264px, 72px)"
          fill="#ff0000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(288px, 72px)"
          fill="#ff0000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(312px, 72px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(336px, 72px)"
          fill="#ff0000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(168px, 96px)"
          fill="#000000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(192px, 96px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(216px, 96px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(240px, 96px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(264px, 96px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(288px, 96px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(312px, 96px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(168px, 120px)"
          fill="#000000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(192px, 120px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(216px, 120px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(240px, 120px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(264px, 120px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(288px, 120px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(312px, 120px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(168px, 144px)"
          fill="#000000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(192px, 144px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(216px, 144px)"
          fill="#000000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(240px, 144px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(264px, 144px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(288px, 144px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(312px, 144px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(528px, 144px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(120px, 168px)"
          fill="#ffaf00"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(144px, 168px)"
          fill="#ffaf00"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(168px, 168px)"
          fill="#ffaf00"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(192px, 168px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(216px, 168px)"
          fill="#000000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(240px, 168px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(264px, 168px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(288px, 168px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(312px, 168px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(528px, 168px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(96px, 192px)"
          fill="#ffaf00"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(120px, 192px)"
          fill="#ffaf00"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(144px, 192px)"
          fill="#ffaf00"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(168px, 192px)"
          fill="#ffaf00"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(192px, 192px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(216px, 192px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(240px, 192px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(264px, 192px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(288px, 192px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(312px, 192px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(504px, 192px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(528px, 192px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(120px, 216px)"
          fill="#ffaf00"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(144px, 216px)"
          fill="#ffaf00"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(168px, 216px)"
          fill="#ffaf00"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(192px, 216px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(216px, 216px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(240px, 216px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(264px, 216px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(288px, 216px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(312px, 216px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(480px, 216px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(504px, 216px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(528px, 216px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(144px, 240px)"
          fill="#ff0000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(168px, 240px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(192px, 240px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(216px, 240px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(240px, 240px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(264px, 240px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(288px, 240px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(312px, 240px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(336px, 240px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(360px, 240px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(384px, 240px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(408px, 240px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(432px, 240px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(456px, 240px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(480px, 240px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(504px, 240px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(528px, 240px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(168px, 264px)"
          fill="#ff0000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(192px, 264px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(216px, 264px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(240px, 264px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(264px, 264px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(288px, 264px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(312px, 264px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(336px, 264px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(360px, 264px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(384px, 264px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(408px, 264px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(432px, 264px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(456px, 264px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(480px, 264px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(504px, 264px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(528px, 264px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(168px, 288px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(192px, 288px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(216px, 288px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(240px, 288px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(264px, 288px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(288px, 288px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(312px, 288px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(336px, 288px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(360px, 288px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(384px, 288px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(408px, 288px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(432px, 288px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(456px, 288px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(480px, 288px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(504px, 288px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(528px, 288px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(168px, 312px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(192px, 312px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(216px, 312px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(240px, 312px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(264px, 312px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(288px, 312px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(312px, 312px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(336px, 312px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(360px, 312px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(384px, 312px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(408px, 312px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(432px, 312px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(456px, 312px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(480px, 312px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(504px, 312px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(528px, 312px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(168px, 336px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(192px, 336px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(216px, 336px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(240px, 336px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(264px, 336px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(288px, 336px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(312px, 336px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(336px, 336px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(360px, 336px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(384px, 336px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(408px, 336px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(432px, 336px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(456px, 336px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(480px, 336px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(504px, 336px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(528px, 336px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(168px, 360px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(192px, 360px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(216px, 360px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(240px, 360px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(264px, 360px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(288px, 360px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(312px, 360px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(336px, 360px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(360px, 360px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(384px, 360px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(408px, 360px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(432px, 360px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(456px, 360px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(480px, 360px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(504px, 360px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(168px, 384px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(192px, 384px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(216px, 384px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(240px, 384px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(264px, 384px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(288px, 384px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(312px, 384px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(336px, 384px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(360px, 384px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(384px, 384px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(408px, 384px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(432px, 384px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(456px, 384px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(480px, 384px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(504px, 384px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(192px, 408px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(216px, 408px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(240px, 408px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(264px, 408px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(288px, 408px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(312px, 408px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(336px, 408px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(360px, 408px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(384px, 408px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(408px, 408px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(432px, 408px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(456px, 408px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(480px, 408px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(216px, 432px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(240px, 432px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(264px, 432px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(288px, 432px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(312px, 432px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(336px, 432px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(360px, 432px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(384px, 432px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(408px, 432px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(432px, 432px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(456px, 432px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(480px, 432px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(240px, 456px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(264px, 456px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(288px, 456px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(312px, 456px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(336px, 456px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(360px, 456px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(384px, 456px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(408px, 456px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(432px, 456px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(456px, 456px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(288px, 480px)"
          fill="#ffaf00"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(384px, 480px)"
          fill="#ffaf00"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(288px, 504px)"
          fill="#ffaf00"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(360px, 504px)"
          fill="#ffaf00"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(384px, 504px)"
          fill="#ffaf00"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(408px, 504px)"
          fill="#ffaf00"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(264px, 528px)"
          fill="#ffaf00"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(288px, 528px)"
          fill="#ffaf00"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(312px, 528px)"
          fill="#ffaf00"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(48px, 552px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(72px, 552px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(96px, 552px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(120px, 552px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(144px, 552px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(168px, 552px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(192px, 552px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(216px, 552px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(240px, 552px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(264px, 552px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(288px, 552px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(312px, 552px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(336px, 552px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(360px, 552px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(384px, 552px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(408px, 552px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(432px, 552px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(456px, 552px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(480px, 552px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(504px, 552px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(528px, 552px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(552px, 552px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(576px, 552px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(48px, 576px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(72px, 576px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(96px, 576px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(120px, 576px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(144px, 576px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(168px, 576px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(192px, 576px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(216px, 576px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(240px, 576px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(264px, 576px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(288px, 576px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(312px, 576px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(336px, 576px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(360px, 576px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(384px, 576px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(408px, 576px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(432px, 576px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(456px, 576px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(480px, 576px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(504px, 576px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(528px, 576px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(552px, 576px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(576px, 576px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(48px, 600px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(72px, 600px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(96px, 600px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(120px, 600px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(144px, 600px)"
          fill="#bb9302"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(168px, 600px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(192px, 600px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(216px, 600px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(240px, 600px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(264px, 600px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(288px, 600px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(312px, 600px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(336px, 600px)"
          fill="#bb9302"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(360px, 600px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(384px, 600px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(408px, 600px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(432px, 600px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(456px, 600px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(480px, 600px)"
          fill="#bb9302"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(504px, 600px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(528px, 600px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(552px, 600px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(576px, 600px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(48px, 624px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(72px, 624px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(96px, 624px)"
          fill="#bb9302"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(120px, 624px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(144px, 624px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(168px, 624px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(192px, 624px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(216px, 624px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(240px, 624px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(264px, 624px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(288px, 624px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(312px, 624px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(336px, 624px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(360px, 624px)"
          fill="#bb9302"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(384px, 624px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(408px, 624px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(432px, 624px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(456px, 624px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(480px, 624px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(504px, 624px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(528px, 624px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(552px, 624px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(576px, 624px)"
          fill="#bb9302"
        />
      </svg>
    </div>
    <div v-show="f2" class="animation" style="display: none">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 648 648">
        <rect
          width="24"
          height="24"
          style="transform: translate(216px, 48px)"
          fill="#ff0000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(264px, 48px)"
          fill="#ff0000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(216px, 72px)"
          fill="#ff0000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(264px, 72px)"
          fill="#ff0000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(312px, 72px)"
          fill="#ff0000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(192px, 96px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(216px, 96px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(240px, 96px)"
          fill="#ff0000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(264px, 96px)"
          fill="#ff0000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(288px, 96px)"
          fill="#ff0000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(312px, 96px)"
          fill="#ff0000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(168px, 120px)"
          fill="#000000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(192px, 120px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(216px, 120px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(240px, 120px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(264px, 120px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(288px, 120px)"
          fill="#ff0000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(312px, 120px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(168px, 144px)"
          fill="#000000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(192px, 144px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(216px, 144px)"
          fill="#000000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(240px, 144px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(264px, 144px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(288px, 144px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(312px, 144px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(120px, 168px)"
          fill="#ffaf00"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(144px, 168px)"
          fill="#ffaf00"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(168px, 168px)"
          fill="#ffaf00"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(192px, 168px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(216px, 168px)"
          fill="#000000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(240px, 168px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(264px, 168px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(288px, 168px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(312px, 168px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(96px, 192px)"
          fill="#ffaf00"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(120px, 192px)"
          fill="#ffaf00"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(144px, 192px)"
          fill="#ffaf00"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(168px, 192px)"
          fill="#ffaf00"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(192px, 192px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(216px, 192px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(240px, 192px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(264px, 192px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(288px, 192px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(312px, 192px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(528px, 192px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(120px, 216px)"
          fill="#ffaf00"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(144px, 216px)"
          fill="#ffaf00"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(168px, 216px)"
          fill="#ffaf00"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(192px, 216px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(216px, 216px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(240px, 216px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(264px, 216px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(288px, 216px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(312px, 216px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(504px, 216px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(528px, 216px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(144px, 240px)"
          fill="#ff0000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(168px, 240px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(192px, 240px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(216px, 240px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(240px, 240px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(264px, 240px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(288px, 240px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(312px, 240px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(336px, 240px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(360px, 240px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(384px, 240px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(408px, 240px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(432px, 240px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(456px, 240px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(480px, 240px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(504px, 240px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(528px, 240px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(120px, 264px)"
          fill="#ff0000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(168px, 264px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(192px, 264px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(216px, 264px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(240px, 264px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(264px, 264px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(288px, 264px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(312px, 264px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(336px, 264px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(360px, 264px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(384px, 264px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(408px, 264px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(432px, 264px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(456px, 264px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(480px, 264px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(504px, 264px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(528px, 264px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(168px, 288px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(192px, 288px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(216px, 288px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(240px, 288px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(264px, 288px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(288px, 288px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(312px, 288px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(336px, 288px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(360px, 288px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(384px, 288px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(408px, 288px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(432px, 288px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(456px, 288px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(480px, 288px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(504px, 288px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(528px, 288px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(168px, 312px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(192px, 312px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(216px, 312px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(240px, 312px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(264px, 312px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(288px, 312px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(312px, 312px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(336px, 312px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(360px, 312px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(384px, 312px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(408px, 312px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(432px, 312px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(456px, 312px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(480px, 312px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(504px, 312px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(528px, 312px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(168px, 336px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(192px, 336px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(216px, 336px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(240px, 336px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(264px, 336px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(288px, 336px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(312px, 336px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(336px, 336px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(360px, 336px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(384px, 336px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(408px, 336px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(432px, 336px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(456px, 336px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(480px, 336px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(504px, 336px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(528px, 336px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(168px, 360px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(192px, 360px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(216px, 360px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(240px, 360px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(264px, 360px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(288px, 360px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(312px, 360px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(336px, 360px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(360px, 360px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(384px, 360px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(408px, 360px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(432px, 360px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(456px, 360px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(480px, 360px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(504px, 360px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(528px, 360px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(168px, 384px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(192px, 384px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(216px, 384px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(240px, 384px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(264px, 384px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(288px, 384px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(312px, 384px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(336px, 384px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(360px, 384px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(384px, 384px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(408px, 384px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(432px, 384px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(456px, 384px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(480px, 384px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(504px, 384px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(168px, 408px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(192px, 408px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(216px, 408px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(240px, 408px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(264px, 408px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(288px, 408px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(312px, 408px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(336px, 408px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(360px, 408px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(384px, 408px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(408px, 408px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(432px, 408px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(456px, 408px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(480px, 408px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(504px, 408px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(192px, 432px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(216px, 432px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(240px, 432px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(264px, 432px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(288px, 432px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(312px, 432px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(336px, 432px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(360px, 432px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(384px, 432px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(408px, 432px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(432px, 432px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(456px, 432px)"
          fill="#ffffff"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(480px, 432px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(240px, 456px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(264px, 456px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(288px, 456px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(312px, 456px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(336px, 456px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(360px, 456px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(384px, 456px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(408px, 456px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(432px, 456px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(456px, 456px)"
          fill="#190000"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(288px, 480px)"
          fill="#ffaf00"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(384px, 480px)"
          fill="#ffaf00"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(264px, 504px)"
          fill="#ffaf00"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(288px, 504px)"
          fill="#ffaf00"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(312px, 504px)"
          fill="#ffaf00"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(384px, 504px)"
          fill="#ffaf00"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(360px, 528px)"
          fill="#ffaf00"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(384px, 528px)"
          fill="#ffaf00"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(408px, 528px)"
          fill="#ffaf00"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(48px, 552px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(72px, 552px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(96px, 552px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(120px, 552px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(144px, 552px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(168px, 552px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(192px, 552px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(216px, 552px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(240px, 552px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(264px, 552px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(288px, 552px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(312px, 552px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(336px, 552px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(360px, 552px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(384px, 552px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(408px, 552px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(432px, 552px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(456px, 552px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(480px, 552px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(504px, 552px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(528px, 552px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(552px, 552px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(576px, 552px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(48px, 576px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(72px, 576px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(96px, 576px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(120px, 576px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(144px, 576px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(168px, 576px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(192px, 576px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(216px, 576px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(240px, 576px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(264px, 576px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(288px, 576px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(312px, 576px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(336px, 576px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(360px, 576px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(384px, 576px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(408px, 576px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(432px, 576px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(456px, 576px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(480px, 576px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(504px, 576px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(528px, 576px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(552px, 576px)"
          fill="#02bb27"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(576px, 576px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(48px, 600px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(72px, 600px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(96px, 600px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(120px, 600px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(144px, 600px)"
          fill="#bb9302"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(168px, 600px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(192px, 600px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(216px, 600px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(240px, 600px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(264px, 600px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(288px, 600px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(312px, 600px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(336px, 600px)"
          fill="#bb9302"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(360px, 600px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(384px, 600px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(408px, 600px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(432px, 600px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(456px, 600px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(480px, 600px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(504px, 600px)"
          fill="#bb9302"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(528px, 600px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(552px, 600px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(576px, 600px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(48px, 624px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(72px, 624px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(96px, 624px)"
          fill="#bb9302"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(120px, 624px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(144px, 624px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(168px, 624px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(192px, 624px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(216px, 624px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(240px, 624px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(264px, 624px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(288px, 624px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(312px, 624px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(336px, 624px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(360px, 624px)"
          fill="#bb9302"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(384px, 624px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(408px, 624px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(432px, 624px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(456px, 624px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(480px, 624px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(504px, 624px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(528px, 624px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(552px, 624px)"
          fill="#bb6502"
        />
        <rect
          width="24"
          height="24"
          style="transform: translate(576px, 624px)"
          fill="#bb9302"
        />
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  props:['f0','f1','f2']
};
</script>

<style>
</style>